import ExcelJS from "exceljs";

export const downloadData = async (
  data,
  headersForDownload,
  fileName,
  type = ""
) => {
  // Map the headers to corresponding object keys explicitly
  if (type === "xlsx") {
    // Create a new workbook and worksheet
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Sheet1");

    // Map headers and set column widths
    worksheet.columns = headersForDownload.map((header) => ({
      header: header.label,
      key: header.key,
      width: header.width || 35, // Default width is 15 if not provided
    }));

    // Add rows to the worksheet
    data.forEach((row) => {
      worksheet.addRow(
        headersForDownload.reduce((acc, header) => {
          acc[header.key] = row[header.key] || ""; // Add data by key or empty string
          return acc;
        }, {})
      );
    });

    // Write the workbook to a blob
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    // Create a download link and trigger it
    const link = document.createElement("a");
    const url = URL.createObjectURL(blob);
    link.href = url;
    link.download = fileName || "table_data.xlsx";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  } else {
    console.log("1");
    const headers = headersForDownload;
    const csvRows = [];

    // Add headers (only labels)
    csvRows.push(headers.map((header) => header.label).join(","));

    // Add data rows
    data.forEach((row) => {
      const values = headers.map((header) => {
        const value = row[header.key] ?? "";
        return `"${String(value).replace(/"/g, '""')}"`;
      });
      csvRows.push(values.join(","));
    });

    // Convert to CSV format
    const csvData = new Blob([csvRows.join("\n")], { type: "text/csv" });
    const csvUrl = URL.createObjectURL(csvData);

    // Create a download link and trigger it
    const link = document.createElement("a");
    link.href = csvUrl;
    link.download = fileName || "table_data.csv";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }
};
